import React, { useState, useMemo } from 'react'

import './good-group.scss'
import { observer } from 'mobx-react'
import { getBEMCls } from '@/utils/classname'
import { Group } from '@/model/types/goods'
import { Column, Expaned } from '@/components/layout/layout'
import { Spin } from 'antd'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { goodsShelfStore } from '../../store/goods-shelf'
import MallGroupItem from './group-item'
import { mallGoodsStore } from '../../store/mall-goods'
import DropContent from '@/views/main/modules/goods-manage/goods-storage/goods-library/modules/goods-group/drop-content'
import { MALL_DARG_TYPE } from '../../../mall-shelf'
import $msg from '@/utils/message'
import { errorCallBack } from '@/utils'

const MallGoodGroup = observer(() => {
    const getCls = (e?: string, m?: string) => getBEMCls('mall-group', e, m)
    const [groupArr, setGroupArr] = useState<Group[]>([])
    const [secondGroupId] = useState<number>(0)

    const getShelfConfig = () =>
        $post({
            url: '/mall/getshelfconfig',
        }).then(res => {
            goodsShelfStore.setShelfConfig(res)
        })

    const { loading } = useRequest(
        () =>
            $post({
                url: '/mall/getmallgoodsgroup',
            }),
        {
            onSuccess: async (e: Group[]) => {
                await getShelfConfig()
                if (goodsShelfStore.mallShelfConfig?.hot_sold) {
                    goodsShelfStore.setActiveGroupId(0)
                } else {
                    goodsShelfStore.setActiveGroupId(e[0].id)
                    e[0].secondary_group.length && goodsShelfStore.setActiveSecondGroupId(e[0].secondary_group[0].id)
                }
                mallGoodsStore.setMallGoodsGroup(e)
                const addOpenStatus = e.map((item, index) => ({
                    ...item,
                    open: groupArr.length ? !!groupArr[index]?.open : false, // 缓存分组展开状态
                }))
                setGroupArr(addOpenStatus)
            },
            refreshDeps: [goodsShelfStore.updateGroup],
        },
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const showHotSale = useMemo(() => goodsShelfStore.mallShelfConfig?.hot_sold, [goodsShelfStore.mallShelfConfig])

    const handleDrop = useRequest(
        (goods_ids: number[], group_id: number | undefined, secondary_group_id?: number) =>
            $post({
                url: '/mall/changemallgoodsgroup',
                params: {
                    mall_goods_ids: goods_ids,
                    to_group_id: group_id,
                    to_secondary_group_id: secondary_group_id || null,
                    from_group_id: goodsShelfStore.groupId,
                    from_secondary_group_id: goodsShelfStore.secondGroupId || null,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '更改成功')
                goodsShelfStore.setUpdateGroupStatus()
            },
            onError: errorCallBack,
        },
    )

    return (
        <Column className={getCls()}>
            <Spin spinning={loading} className={loading ? getCls('spin') : ''} />
            <Expaned className={getCls('content')}>
                {showHotSale && (
                    <div
                        className={`${goodsShelfStore.groupId === 0 ? getCls('item', 'active') : getCls('item')}`}
                        onClick={() => {
                            goodsShelfStore.setActiveGroupId(0)
                            goodsShelfStore.setActiveSecondGroupId(0)
                        }}
                    >
                        近期热卖
                    </div>
                )}
                {!!groupArr.length &&
                    groupArr.map((group, index) => (
                        <div key={group.id}>
                            {group.secondary_group.length ? (
                                <MallGroupItem
                                    group={group}
                                    groupArr={groupArr}
                                    groupIndex={index}
                                    onDrop={(item, g, s) => {
                                        handleDrop.run(item.goods_ids, group.id, s)
                                    }}
                                    onClick={(val, index) => {
                                        setGroupArr(group => {
                                            const tmp = [...group]
                                            tmp[index].open = !tmp[index].open

                                            return tmp
                                        })
                                    }}
                                    secondGroupId={secondGroupId}
                                />
                            ) : (
                                <DropContent
                                    type={MALL_DARG_TYPE}
                                    onDrop={item => {
                                        console.info(item)
                                        handleDrop.run(item.goods_ids, group.id, 0)
                                    }}
                                >
                                    <MallGroupItem
                                        group={group}
                                        groupArr={groupArr}
                                        groupIndex={index}
                                        secondGroupId={secondGroupId}
                                    />
                                </DropContent>
                            )}
                        </div>
                    ))}
            </Expaned>
        </Column>
    )
})

export default MallGoodGroup
